export const rangeConfigurations = {
  week: {
    singular: 'Week',
    plural: 'Weeks',
  },
  quarter: {
    singular: 'Quarter',
    plural: 'Quarters',
  },
  year: {
    singular: 'Year',
    plural: 'Years',
  },
  month: {
    singular: 'Month',
    plural: 'Months',
  },
  day: {
    singular: 'Day',
    plural: 'Days',
  },
}

export const ranges = Object.keys(rangeConfigurations)

export const defaultOptions = {
  // note defaultRange is not static as it's dependent on range options, if not given in
  // editorOptions it will default to the first range option
  defaultValue: 4,
  rangeName: 'range',
  ranges,
  valueName: 'value',
}
